import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const services = [
    {
        link: '/rct',
        img: 'Rct.jpg',
        alt: 'Root Canal Treatment',
        title: 'Painless Root Canal Treatment',
        desc: 'Save damaged teeth with painless, effective root canal therapy.'
    },
    {
        link: '/dental-implants',
        img: 'Implants.jpg',
        alt: 'Dental Implants',
        title: 'Dental Implants',
        desc: 'Restore missing teeth with durable, natural-looking implants.'
    },
    {
        link: '/wisdom-tooth-extraction',
        img: 'Whitening.jpg',
        alt: 'Wisdom Tooth Extraction',
        title: 'Wisdom Tooth Extraction',
        desc: 'Painless Wisdom Tooth Extraction by experts'
    },
    {
        link: '/braces-aligners',
        img: 'Braces.jpg',
        alt: 'Orthodontics (Braces & Aligners)',
        title: 'Braces & Aligners (Invisible Braces)',
        desc: 'Achieve a perfectly aligned smile with advanced orthodontic treatments.'
    },
    {
        link: '/smile-makeover',
        img: 'Cosmetic.jpg',
        alt: 'Cosmetic Dentistry',
        title: 'Smile Makeover & Teeth Whitening',
        desc: 'Enhance your smile with veneers, bonding, and smile makeovers.'
    },
    {
        link: '/checkups-cleaning',
        img: 'Checkup.jpg',
        alt: 'Routine Checkups & Cleaning',
        title: 'Routine Checkups & Cleaning',
        desc: 'Maintain optimal oral health with regular dental exams and cleanings.'
    },
    {
        link: '/pediatric-dentistry',
        img: 'kids.jpg',
        alt: 'Pediatric Dentistry',
        title: 'Pediatric Dentistry',
        desc: 'Gentle and friendly dental care for children.'
    },
    {
        link: '/gum-disease-treatment',
        img: 'Gums.jpg',
        alt: 'Gum Disease Treatment',
        title: 'Gum Disease Treatment',
        desc: 'Prevent and treat gum infections for a healthier smile.'
    }
];

const Services = () => {
    const scrollRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;

        let animationFrameId;
        const speed = 0.8; // Adjust specific speed logic as needed

        const step = () => {
            if (!isPaused) {
                // If scrolled past the first half (original content), reset to 0
                // We use >= here to catch it if it overshoots slightly
                if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
                    scrollContainer.scrollLeft -= scrollContainer.scrollWidth / 2;
                } else {
                    scrollContainer.scrollLeft += speed;
                }
            }
            animationFrameId = requestAnimationFrame(step);
        };

        animationFrameId = requestAnimationFrame(step);

        return () => cancelAnimationFrame(animationFrameId);
    }, [isPaused]);

    return (
        <section id='services' className='services-section'>
            <div className='services-container'>
                <div className='services-header'>
                    <span className='services-subtitle'>OUR SERVICES</span>
                    <h2 className='services-title'>Dental Clinic Services We Offer in Sector 23, Gurgaon</h2>
                </div>

                <div
                    className='services-grid'
                    ref={scrollRef}
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                    onTouchStart={() => setIsPaused(true)}
                    onTouchEnd={() => setIsPaused(false)}
                >
                    {/* Render the list twice for seamless infinite scrolling */}
                    {[...services, ...services].map((service, index) => (
                        <Link key={index} to={service.link} className='service-card-link'>
                            <div className='service-card'>
                                <div className='service-icon'>
                                    <img src={service.img} alt={service.alt} />
                                </div>
                                <h3>{service.title}</h3>
                                <p>{service.desc}</p>
                                <span className='read-more-btn'>Learn More</span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
